// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCB3P4oRP4WI-Vlzd6DIFGDGwJDFc1MXQ8",
    authDomain: "jperfectsolution-490f2.firebaseapp.com",
    databaseURL: "https://jperfectsolution-490f2.firebaseio.com",
    projectId: "jperfectsolution-490f2",
    storageBucket: "jperfectsolution-490f2.appspot.com",
    messagingSenderId: "843403111538",
    appId: "1:843403111538:web:97be943b9dac154d2866eb",
    measurementId: "G-GR0XQGMQY8"
  },
  baseUrl: 'http://localhost:5000/',
  mailURL: 'https://us-central1-j-perfectsolution.cloudfunctions.net/sendMail'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
